<script>
import ErrorBoundary from "../components/error/ErrorBoundary";
import {ModalsContainer} from "vue-final-modal";

export default {
    name: "PmApp",
    components: {
        ErrorBoundary,
        ModalsContainer
    }
}
</script>

<template>
    <ErrorBoundary>
        <router-view />
    </ErrorBoundary>
    <modals-container />
</template>
